import { qualifiesForDraughtDuty } from "@sellar-io/common";
import { BasketOrderItem } from "../../../../hooks";
import { CheckoutOrderItem } from "./types";
import { buildDietaryList } from "../../../../components/dietaryDisplayList/buildDietaryList";

export const mapBasketOrderToCheckoutOrderItems = (
  basketOrderItems: BasketOrderItem[],
  supplierName?: string,
): CheckoutOrderItem[] => {
  return basketOrderItems.map((item) => {
    const nameAndDescription = item.Product.name?.split("•") ?? [];
    const title = nameAndDescription[0] ?? "";
    const description = nameAndDescription[1] ?? "";

    return {
      productId: item.ProductId,
      title,
      description,
      imageUrl: item.Product.imageUrl || item.Product.Parent?.imageUrl || "",
      price: item.price,
      quantity: item.quantity,
      dietaryTypes: buildDietaryList({
        childProduct: {
          vegan: item.Product.vegan,
          lactoseFree: item.Product.lactoseFree,
          glutenFree: item.Product.glutenFree,
        },
        parentProduct: {
          vegan: item.Product.Parent?.vegan,
          lactoseFree: item.Product.Parent?.lactoseFree,
          glutenFree: item.Product.Parent?.glutenFree,
        },
      }),
      availableFrom: item.Product.availableFrom,
      availableStock: item.Product.availableStock,
      canBackOrder: item.Product.canBackorder,
      qualifiesForDraughtDuty: qualifiesForDraughtDuty(item.Product),
      promotionRewardItemId: item.PromotionRewardItemId ?? null,
      promotionAppliedAt: item.promotionAppliedAt ?? null,
      supplierName,
    };
  });
};
